import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import { Box } from '@mui/material';

import useStores from 'hooks/use-stores';
import ItemSegment from 'main/components/advert/ItemSegment';
import { FooterBar } from 'main/components/bar/FooterBar';
import LoginNotification from 'pages/components/LoginNotification';
import isEmpty from 'utils/is-empty';

import Content from './components/Content';
import HistoryOfChangesProvider from './components/HistoryOfChangesProvider';
import PrivateArea from './components/Private';
import Related from './components/Related';
import RelatedBox from './components/RelatedBox';
import Score from './components/Score';
import useStyles from './styles';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    references: any;
}

const Item: React.FC<Props> = ({ data, references }) => {
    const { classes } = useStyles();
    const { naslStore } = useStores();

    useEffect(() => {
        if (isEmpty(naslStore.naslTypes)) {
            naslStore.loadTypes();
        }
    }, [naslStore]);

    if (!data) {
        return null;
    }

    const aiScore = data.enchantments?.score;
    const { cvss2, cvss3, epss, id, type, privateArea } = data;

    return (
        <HistoryOfChangesProvider id={id}>
            <Box display="flex" flexDirection="row" className={classes.item}>
                <Box className={classes.contentWrapper}>
                    <Box className={classes.content}>
                        <Content data={data} />
                    </Box>

                    {data.id && <ItemSegment item={data} />}

                    {privateArea && (
                        <Box className={classes.privateArea}>
                            <PrivateArea bulletinType={type} privateArea={privateArea} />
                        </Box>
                    )}

                    {!isEmpty(references) && (
                        <Box className={classes.related}>
                            <Related references={references} />
                        </Box>
                    )}
                    <FooterBar />
                </Box>
                <Box className={classes.score}>
                    <Score aiScore={aiScore} cvss2={cvss2} cvss3={cvss3} epss={epss} id={id} />
                    {!isEmpty(references) && <RelatedBox cveId={id} references={references} />}
                </Box>
            </Box>
            <LoginNotification />
        </HistoryOfChangesProvider>
    );
};

export default observer(Item);
